import { IconType } from 'react-icons';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaXTwitter,
  FaYoutube,
  FaTiktok,
  FaGlobe,
} from "react-icons/fa6";
import type { SocialPlatform } from "@/lib/types";

interface SocialIconConfig {
  icon: IconType;
  color: string;
  name: string;
}

const SOCIAL_ICON_MAP: Record<string, SocialIconConfig> = {
  facebook: { icon: FaFacebook, color: "#1877F2", name: "Facebook" },
  instagram: { icon: FaInstagram, color: "#E4405F", name: "Instagram" },
  linkedin: { icon: FaLinkedin, color: "#0A66C2", name: "LinkedIn" },
  x: { icon: FaXTwitter, color: "#000000", name: "X (Twitter)" },
  youtube: { icon: FaYoutube, color: "#FF0000", name: "YouTube" },
  tiktok: { icon: FaTiktok, color: "#000000", name: "TikTok" },
};

/** Trả về icon + màu tương ứng với platform; fallback về icon Globe nếu chưa định nghĩa. */
export function getSocialIcon(type: SocialPlatform): SocialIconConfig {
  return SOCIAL_ICON_MAP[type.toLowerCase()] ?? { icon: FaGlobe, color: "#0077bb", name: type };
}
